import { useLocation } from 'wouter'
import { MVP } from '../../mvp'
import { ROUTES } from '../../routes'
import useDossierExposant from '../../hooks/useDossierExposant'
import { avecAlpha } from '../../lib/couleurs'

const TEAL = 'rgb(var(--c-teal))'
const VERT = 'rgb(var(--c-green))'

/**
 * Carte d'accueil « Vos pièces sont en vérification » (prototype v7.5).
 * SEULEMENT au niveau VERIFICATION : l'appel « à compléter » vit dans la bulle
 * RINA de chaque page (D6) — on ne le double pas ici.
 */
export default function CarteDossierAccueil() {
  const [, setLocation] = useLocation()
  const etat = useDossierExposant({ enabled: MVP.DOSSIER_EXPOSANT })
  if (!MVP.DOSSIER_EXPOSANT || etat?.niveau !== 'VERIFICATION') return null
  return (
    <button
      onClick={() => setLocation(ROUTES.compte.dossier)}
      className="glass-surface rounded-3xl mt-3 w-full text-left flex items-center gap-[13px]"
      style={{ padding: '16px 18px', borderLeft: `4px solid ${TEAL}`, animation: 'riseIn .5s .06s ease both' }}
    >
      <span className="w-[46px] h-[46px] rounded-2xl flex items-center justify-center text-[23px] flex-shrink-0" style={{ background: avecAlpha(TEAL, 0.15) }}>📋</span>
      <span className="flex-1 min-w-0">
        <span className="block text-[10px] uppercase font-extrabold" style={{ letterSpacing: 2, color: TEAL }}>Dossier exposant</span>
        <span className="block text-[14.5px] font-bold mt-[3px]" style={{ color: VERT }}>Vos pièces sont en vérification</span>
        <span className="block text-[11.5px] mt-0.5" style={{ color: 'rgba(7,62,61,0.55)' }}>Réponse de l'équipe sous 48-72h.</span>
      </span>
      <span className="text-[12px] font-extrabold rounded-full flex-shrink-0" style={{ color: VERT, background: avecAlpha(TEAL, 0.15), padding: '8px 12px' }}>Voir ›</span>
    </button>
  )
}
